/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetMerchantsLogoUrls$Params {
  limit?: number;
  randomize?: boolean;
}

export function getMerchantsLogoUrls(http: HttpClient, rootUrl: string, params?: GetMerchantsLogoUrls$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, getMerchantsLogoUrls.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('randomize', params.randomize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

getMerchantsLogoUrls.PATH = '/public/banner_logos';
